import { Navigation } from "../navigation/navigation";
import Footer from "../footer/footer";
import VideoPlayer from "../video-player/video-player";

const shuffleArray = (array: string[]) => {
  let currentIndex = array.length,
    randomIndex;

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

const Home = () => {
  const videoCarrusell = [
    "https://relaxai.s3.us-west-2.amazonaws.com/AB-001.mp4",
    "https://relaxai.s3.us-west-2.amazonaws.com/AB-002.mp4",
    "https://relaxai.s3.us-west-2.amazonaws.com/AB-003.mp4",
    "https://relaxai.s3.us-west-2.amazonaws.com/AB-004.mp4",
    "https://relaxai.s3.us-west-2.amazonaws.com/AB-005.mp4",
    "https://relaxai.s3.us-west-2.amazonaws.com/AB-006.mp4",
    "https://relaxai.s3.us-west-2.amazonaws.com/AB-007.mp4",
  ];

  const posterUrl = "https://dummyimage.com/600x400/2525cf/fff";
  const shuffledVideoCarrusell = shuffleArray([...videoCarrusell]);
  return (
    <>
      <Navigation />
      <VideoPlayer poster={posterUrl} videoSource={shuffledVideoCarrusell} />
      <Footer />
    </>
  );
};

export default Home;
